// we show the user micro-units but insulin precision is measured in milliunits
export function insulinUnitsToPrecision(units: number) {
  return units * 1000
}
